import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * MuiList
 *
 * https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?type=design&node-id=676-36676&mode=design&t=wr38VczbXqqPhfGf-0
 */
const MuiList = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '& > .MuiListItemButton-root:not(.MuiListItemButton-dense)': {
        marginBottom: theme.spacing(2),
        '&:last-child': {
          marginBottom: 0
        }
      }
    })
  }
};

/**
 * MuiListItemButton
 *
 * https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?type=design&node-id=676-36676&mode=design&t=wr38VczbXqqPhfGf-0
 */
export const MuiListItemButton = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      backgroundColor: theme.palette.common.white,
      borderRadius: 12
    })
  }
};

/**
 * MuiListItemText
 *
 * https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?type=design&node-id=676-36676&mode=design&t=wr38VczbXqqPhfGf-0
 */
export const MuiListItemText = {
  styleOverrides: {
    primary: ({
      theme
    }) => _extends({}, theme.typography.subtitle2),
    secondary: ({
      theme
    }) => _extends({}, theme.typography.body2, {
      color: theme.palette.text.secondary
    })
  }
};
export default MuiList;